import { ProductPage } from '@/pages/ProductPage';
import { loadCJ925PreviewProduct } from '@/services/cj925PreviewStore';
import { navigate } from '@/hooks/useRoute';

export function CJ925ProductPreviewPage({productId}:{productId:number}){
 const product=loadCJ925PreviewProduct(productId);
 if(!product)return <section className="section empty"><h1>תצוגת המוצר לא נמצאה</h1><button className="btn gold" onClick={()=>navigate('/admin/cj925-import')}>חזרה ל-CJ925 Import</button></section>;
 return <>
  <div style={{padding:'10px 16px',textAlign:'center',fontWeight:700,background:'#171512',color:'#fff'}}>CJ925 PREVIEW · המוצר עדיין לא פורסם ולא נשמר ב-Supabase</div>
  <ProductPage slug={product.slug} previewProduct={product}/>
 </>;
}
